// src/pages/produtos/produtos/AdicionaisTab.js
// pages/produtos/produtos/AdicionaisTab.js
import React, { useEffect, useState } from 'react';
import { MdDelete } from "react-icons/md";
import { IoMdAddCircle } from "react-icons/io";
import Input from '../../../components/input/Input';
import InputCheck from '../../../components/input/InputCheck';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useProduto } from '../../../contexts/produtos/ProdutoContext';
import { useAdicional } from '../../../contexts/produtos/AdicionalContext';

const AdicionaisTab = ({
    produto,
    setProduto,
    disableId,
    disableCampos,
}) => {
    const { showMessage } = useMessage();
    
    const { setProdutos } = useProduto();  
    const { adicionaisProduto, setAdicionaisProduto, addAdicional, deleteAdicional } = useAdicional();
    const [novoAdicional, setNovoAdicional] = useState({ descricao: '', preco: '', obrigatorio: false });    

    useEffect(() => {
        setNovoAdicional({ descricao: '', preco: '', obrigatorio: false });
    }, [produto.id]);

    const handleAddAdicional = async (e) => {
        e.preventDefault();
        if (!novoAdicional.descricao || !novoAdicional.preco) {
            showMessage("Preencha descrição e preço do adicional!");
            return;
        }

        const preco = parseFloat(novoAdicional.preco.replace(',', '.'));
        if (isNaN(preco) || preco < 0) {
            showMessage("Preço inválido!");
            return;
        }

        let novo = {
            id: 0,
            produtoId: produto.id || 0,
            descricao: novoAdicional.descricao,
            preco: preco,
            obrigatorio: novoAdicional.obrigatorio || false
        };

        if (disableId === true) {
            try {
                const response = await addAdicional(novo);
                if (response && response.descricao && response.preco) {
                    novo = response;
                } else {
                    console.error('Invalid response from addAdicional:', response);
                    showMessage("Erro ao adicionar adicional no servidor!");
                }
            } catch (error) {
                console.error('Error in addAdicional:', error);
                showMessage("Erro ao adicionar adicional no servidor!");
            }
        }

        const novosAdicionais = [...adicionaisProduto, novo];
        setAdicionaisProduto(novosAdicionais);
        setProduto({
            ...produto,
            adicionais: novosAdicionais
        });
        setProdutos(prev =>
            prev.map(p =>
                p.id === produto.id
                    ? { ...p, adicionais: novosAdicionais }
                    : p
            )
        );
        setNovoAdicional({ descricao: '', preco: '', obrigatorio: false });
    };

    const handleRemoveAdicional = (index) => {
        const adicional = adicionaisProduto[index];
        if (disableId) {
            deleteAdicional(adicional.id);
        }        
        const novosAdicionais = adicionaisProduto.filter((_, i) => i !== index);

        setAdicionaisProduto(novosAdicionais);
        setProduto({
            ...produto,
            adicionais: novosAdicionais
        });

        setProdutos(prev =>
            prev.map(p =>
                p.id === produto.id
                    ? { ...p, adicionais: novosAdicionais }
                    : p
            )
        );
    };

    return (        
        <div>
            <div className="input-group" style={{marginBottom:'10px', alignItems:'end'}}>
                <Input
                    label="Descrição"
                    value={novoAdicional.descricao}
                    onChange={(e) => setNovoAdicional({ ...novoAdicional, descricao: e.target.value })}
                    disabled={disableCampos}
                    size={300}
                />
                <Input
                    label="Preço"
                    value={novoAdicional.preco}
                    onChange={(e) => {
                        let inputValue = e.target.value;
                        setNovoAdicional({ ...novoAdicional, preco: inputValue });
                    }}
                    onBlur={() => {
                        const preco = novoAdicional.preco.toString().replace(',', '.');
                        const precoFormated = parseFloat((preco || '0'));
                        const formatted = precoFormated.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        });
                        setNovoAdicional({ ...novoAdicional, preco: formatted });
                    }}
                    disabled={disableCampos}
                    type="text"
                    size={80}
                    style={{ textAlign: 'right' }}
                />
                <InputCheck
                    id="adicionalObrigatorio"
                    label="Obrigatorio"
                    checked={novoAdicional.obrigatorio}
                    onChange={(e) => setNovoAdicional({ ...novoAdicional, obrigatorio: e.target.checked })}
                    disabled={disableCampos}
                />
                {produto?.id > 0 && (
                    <div style={{ marginTop: "8px" }}>   
                        <button
                            className="btn btn-secondary"
                            onClick={handleAddAdicional}
                            disabled={disableCampos}
                        >
                            <IoMdAddCircle /> Adicionar
                        </button>
                    </div>  
                )}
                
                   
            </div>
            <div className="table-responsive" style={{marginTop:'10px'}}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th>Preço</th>
                            <th>Obrigatorio</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {adicionaisProduto.map((adicional, index) => (
                            <tr key={index}>
                                <td>{adicional.descricao}</td>
                                <td style={{ textAlign: 'right' }}>
                                    {adicional.preco.toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    {adicional.obrigatorio ? 'Sim' : 'Nao'}
                                </td>
                                <td>
                                    <button
                                        type='button'
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleRemoveAdicional(index)}
                                        disabled={disableCampos}
                                    >
                                        <MdDelete />
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {adicionaisProduto.length === 0 && (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    Nenhum adicional cadastrado
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdicionaisTab;
